import handleCart from "./handlecart";
import { combineReducers } from "redux";

const rootReducers = combineReducers({ handleCart })

export default rootReducers;
